<style lang="stylus">
    .buypackage-modal
        position fixed
        overflow auto
        top 0
        right 0
        bottom 0
        left 0
        z-index 99999
        background rgba(55,55,55,.6)
        .buypackage-content
            width 436px
            height 422px
            position absolute
            transform translate(-50%, -50%)
            left 50%
            top 50%
            transition: transform .7s cubic-bezier(.17,.67,.38,.84);
            .buypackage-close
                position absolute
                right 88px
                top 78px
                cursor pointer
            .buypackage-img
                width 100%
                height 100%
                display block
            .buypackage-btn
                position absolute
                width 190px
                height 48px
                bottom 84px;
                left 123px
                z-index 1
                cursor pointer
                background-image url("../img/buy/buy-btn.png")
                background-size cover
                font-size 16px
                font-weight 600
                color white
                display flex
                align-items center
                justify-content center
                box-shadow: 9px 11px 13.4px 0px #FFFFFF59 inset;
                box-shadow: 2px 1px 4px 0px #92000061 inset;
                box-shadow: -3px -3px 19.3px 0px #C2000040 inset;
                box-shadow: 0px 1.5px 3px 0px #B3000040;
                border-radius 36.09px
</style>

<template>
    <div class="buypackage-modal" v-if="value" @click.stop>
        <div class="buypackage-content" ref="content" :style="conStyle">
            <div class="buypackage-close" @click="closeModal(true)">
                <img src="@/public/img/buy/close.svg" alt="close" />
            </div>
            <img class="buypackage-img" src="@/public/img/buy/package.png" alt="discount" />
            <div class="buypackage-btn" @click="toBuy">立即购买({{ down }}s)</div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch, Prop } from "vue-property-decorator";
    @Component({})
    export default class BuyPackage extends Vue {
        down = 10;
        timer = null;
        @Prop({ required: true, type: Boolean }) value: boolean;
        @Prop({ default: "default", type: String }) type: string;
        @Prop({ default: () => {}, type: Function }) showCallback: Function;
        @Watch("value")
        watchShow() {
            if (this.value) {
                this.timer = setInterval(() => {
                    if (this.down <= 1) {
                        this.closeModal(false);
                        clearInterval(this.timer);
                        return;
                    }
                    this.down--;
                }, 1000);
            } else {
                clearInterval(this.timer);
            }
        }
        toBuy() {
            this.$emit("input", false);
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "other",
            });
            this.$store.commit("toPublicStatus", {
                type: "upgradeSuffix",
                data: "action=sixmonth",
            });
            if (this.type === "slider") {
                this.showCallback(3);
            } else {
                this.$store.commit("toPublicStatus", {
                    type: "showBuyframe",
                    data: true,
                });
            }
            this.sensors.track("strategicPopupClick", {
                popup_type: "sku_popup",
                button_type: "get_button",
            });
        }
        conStyle = null;
        closeModal(fromIcon) {
            this.sensors.track("strategicPopupClose", {
                popup_type: "sku_popup",
                close_reason: fromIcon ? "click" : "overtime",
            });
            let id = "#vip-btn";
            if (this.type === "slider") {
                id = "#vip-btn-slider";
            }
            const vipBtn = document.querySelector(id).getBoundingClientRect();
            const content = (<HTMLDivElement>this.$refs.content).getBoundingClientRect();
            const deltaX = vipBtn.left - content.left - content.width + vipBtn.width / 2;
            const deltaY = vipBtn.top - content.top - content.height + vipBtn.height / 2;
            (<HTMLDivElement>this.$el).style.background = "transparent";
            this.conStyle = {
                transform: `translate(${deltaX}px, ${deltaY}px) scale(0.05)`,
                willChange: "transform",
            };
            setTimeout(() => {
                this.$emit("input", false);
                this.conStyle = null;
            }, 700);
        }
    }
</script>
